import { db } from "@react-native-firebase/database";
import { NavProps } from "core/interfaces";
import { get, ref } from "firebase/database";
import { useEffect, useRef, useState } from "react";
import { Dimensions } from "react-native";
import { DEFAULT_USER_IMAGE, MOBILE_VIEW_WIDTH } from "res/constants";
import Loader from "src/components/Loader";
import TimeTrackingTable from "src/components/TimeTrackingTable";
import Menu from "./Menu";
import styles from "./styles/UserDetailsScreenStyles";

var currentUserId = ''
export const getCurrentUserId = () => { return currentUserId }
const setCurrentUserId = (iD: string) => { currentUserId = iD }
export default function UserDetailsScreen({ user }: NavProps) {
  const [showToast, setShowToast] = useState<boolean>()
  const screenWidth = Dimensions.get('window').width;
  const [timeRecords, setTimeRecords] = useState([]);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [showLoader, setShowLoader] = useState(false);

  const UserData = user 
  const getUserTimeRecords = async () => {
    setShowLoader(true)
    // if(UserData&&UserData.id){
    try {
      const dbRef = ref(
        db,
        `timeRecord/${UserData.id}`
      );
      await get(dbRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.val();
            const records: any = [];
            Object.keys(data).forEach((key) => {
              const recordArray = Object.keys(data[key]).map((key2) => {
                const { startTime, endTime, duration, projectName, taskSummary } = data[key][key2];
                return { startTime, endTime, duration, uid: key2, projectName, taskSummary };
              });
              records.push({ date: key, records: recordArray });
            });
            setShowToast(false)
            setTimeRecords(records.reverse());
            setShowLoader(false)
          } else {
            setShowToast(false)
            console.log("No data available for the specified date.");
            setShowLoader(false)
          }
        })
        .catch((error) => {
          setShowToast(false)
          console.error("Failed to retrieve data:", error);
          setShowLoader(false)
        });
    }
    catch (error: any) {
      console.error("Error reading data:", error.message);
      setShowLoader(false)
    }
  };
  useEffect(() => {
    setShowToast(true)
    getUserTimeRecords();
    setCurrentUserId((UserData && UserData.id) ? UserData.id : '')
  }, []);


  return (
    <div style={styles.outer}>
      <Menu backEnabled={true} />
      <div ref={scrollContainerRef} style={{ overflowX: "hidden", width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "100%", }}>
        <div style={{ width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "97%",padding: screenWidth > MOBILE_VIEW_WIDTH ? "0 0 0 20px" : "", margin: "auto" }}>
          <div style={{...styles.topBar,textAlign: screenWidth > MOBILE_VIEW_WIDTH ? 'left' : 'center' }}>
            {screenWidth <= MOBILE_VIEW_WIDTH && <div style={styles.icon}></div>}
            {screenWidth <= MOBILE_VIEW_WIDTH &&
              <div style={styles.generalMobile}>
                <div style={styles.userViewMobile}>{user ? `${user.firstName} ${user.lastName}` : ''}
                </div>
                <div><img src={(UserData && UserData?.image) ? UserData.image : DEFAULT_USER_IMAGE} style={styles.image} /></div>
              </div>}
            {screenWidth > MOBILE_VIEW_WIDTH &&
              <div style={styles.general}>
                <div style={styles.userView}>{user ? `${user.firstName} ${user.lastName}` : ''}</div>
                <div><img src={(UserData && UserData?.image) ? UserData.image : DEFAULT_USER_IMAGE} style={styles.secondaryImage} /></div>
              </div>}
            {screenWidth <= MOBILE_VIEW_WIDTH &&
              <div style={styles.dummy}></div>}
          </div>
          <p onClick={getUserTimeRecords}  style={{textDecoration:"underline",color:"blue",cursor:"pointer"}}>Refresh</p>
        </div> 
        <div style={{ marginTop: 50, padding: screenWidth > MOBILE_VIEW_WIDTH ? "20px" : "16px" }}>
          {showToast === true && <Loader />}
          <TimeTrackingTable TimeTrackingRecords={timeRecords} userDetailsScreen={true} scrollContainerRef={scrollContainerRef} getUserTimeRecords={getUserTimeRecords} UserData={UserData} />
        </div>
      </div>
      {showLoader && <Loader />}
    </div>
  );
}
